<template>
    <b-dropdown v-bind="$attrs" v-on="$listeners" variant="light" no-caret class="dropdown" size="sm">
        <template #button-content>
            <div :style="`background-image: url(${icons.globe});`" class="icons mr-2" />
            <span v-text="locales[currentLocale]" />
            <div :style="`background-image: url(${icons.chevronDown});`" class="icons ml-2" />
        </template>
        <b-dropdown-item-button
            v-for="(text, locale) in locales"
            :key="locale"
            @click="setSystemCurrentLocale(locale)"
            button-class="btn-sm"
        >
            {{ text }}
        </b-dropdown-item-button>
    </b-dropdown>
</template>

<script>
import globe from '@/assets/icons/globe.svg'
import chevronDown from '@/assets/icons/chevron-down.svg'
import systemLocaleMixin from '@/mixins/systemLocaleMixin'

export default {
    name: 'BtnDropdownLanguage',
    mixins: [systemLocaleMixin],
    data() {
        return {
            icons: {
                globe: globe,
                chevronDown: chevronDown,
            },
        }
    },
}
</script>

<style lang="scss" scoped>
.dropdown {
    border: 1px solid #666;
    border-radius: 4px;
    span {
        font-weight: 700;
        color: #666;
    }
    .icons {
        width: 16px;
        height: 17px;
        display: inline-block;
        background-repeat: no-repeat;
    }
    span,
    .icons {
        vertical-align: middle;
    }
}
</style>

<style lang="scss">
.dropdown {
    .btn-light {
        background-color: #fff;
    }
    .btn-light:hover,
    .btn-light:active {
        background-color: #d9e1e6;
    }
}
</style>
